<script>
    import DynamicPage from '../components/pages/DynamicPage/DynamicPage';

    export default {
        extends: DynamicPage,
    };
</script>
